import {
  QueueBottomIcon,
  QueueTopIcon,
  PinIcon,
  ShareIcon,
  type IconProps,
} from '@buffer-mono/popcorn'

import type { ScheduleOption } from './types'

export const SCHEDULE_OPTIONS: Record<
  ScheduleOption,
  {
    icon: React.FC<IconProps>
    label: string
    description?: string
    withSeparator?: boolean
  }
> = {
  Queue: {
    icon: QueueBottomIcon,
    label: 'Next Available',
    description: 'Your post will go out after any other queued posts.',
  },
  Prioritize: {
    icon: QueueTopIcon,
    label: 'Prioritize',
    description: 'Your post will be bumped to the top of the queue.',
  },
  Now: {
    icon: ShareIcon,
    label: 'Now',
    description: 'Your post will be sent out right away.',
  },
  FixedTime: {
    icon: PinIcon,
    label: 'Set Date and Time',
    withSeparator: true,
  },
}

export const SCHEDULE_OPTIONS_FOR_EDIT_MODES: ScheduleOption[] = [
  'Queue',
  'Prioritize',
  'FixedTime',
]

export const SCHEDULE_OPTIONS_FOR_APPROVAL_REQUIRED: ScheduleOption[] = [
  'Queue',
  'FixedTime',
]

export const DEFAULT_SCHEDULE_OPTIONS: ScheduleOption[] = [
  'Queue',
  'Prioritize',
  'Now',
  'FixedTime',
]
